import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// @mui material components
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDBadgeDot from 'components/MDBadgeDot';

// Material Dashboard 2 PRO React examples
import PieChart from 'examples/Charts/PieChart';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import ComplexStatisticsCard from 'examples/Cards/StatisticsCards/ComplexStatisticsCard';
import DefaultLineChart from 'examples/Charts/LineCharts/DefaultLineChart';
import VerticalBarChart from 'examples/Charts/BarCharts/VerticalBarChart';
import HorizontalBarChart from 'examples/Charts/BarCharts/HorizontalBarChart';

import { getCostPOSummary } from 'services/Criteria';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

// Material Dashboard 2 PRO React examples
import Navbar from 'examples/Navbars/NavBar';

const initChart = {
  title: '',
  description: '',
  date: '',
  chart: {
    labels: [],
    datasets: [],
  },
};

function DashboardPurchase() {
  const mod = 'dashboard_purchase';
  const { t, i18n } = useTranslation();
  const app = useSelector((state) => state[APP_STATE]);
  const [sale, setSale] = useState([]);
  const [chartPie, setChartPie] = useState(initChart);
  const [chartLine, setChartLine] = useState(initChart);
  const [chartVertical, setChartVertical] = useState(initChart);
  const [chartHorizontal, setChartHorizontal] = useState(initChart);
  const [listPie, setListPie] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stat, setStat] = useState({
    stat1: { count: '-', color: 'white', amount: '', label: 'Loading...' },
    stat2: { count: '-', color: 'white', amount: '', label: 'Loading...' },
    stat3: { count: '-', color: 'white', amount: '', label: 'Loading...' },
    stat4: { count: '-', color: 'white', amount: '', label: 'Loading...' },
    stat5: { count: '-', color: 'white', amount: '', label: 'Loading...' },
    stat6: { count: '-', color: 'white', amount: '', label: 'Loading...' },
  });
  const [criteria, setCriteria] = useState([]);

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setStat(result.stat);
        setChartPie(result.pie);
        setChartLine(result.line);
        setChartVertical(result.vertical);
        setChartHorizontal(result.horizontal);
        setSale(result.sale);
        setListPie(result.pie.list);
        setLoading(false);
      } else {
        Func.exitApp();
      }
    });

    getCostPOSummary(app.token).then((res) => {
      setCriteria(res);
    });
  };

  const renderStat = () => {
    return (
      <MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              {/* <ComplexStatisticsCard
                color="dark"
                icon="hourglass_top"
                title="รอจัดซื้อ"
                count={stat.stat1.count}
                percentage={{
                  color: stat.stat1.color,
                  amount: stat.stat1.amount,
                  label: stat.stat1.label,
                }}
              /> */}
              <Card sx={{ height: '100%' }}>
                <MDBox py={1.5} pr={2} pl={3}>
                  <MDBox>
                    <MDTypography variant='h6'>งบคงเหลือ</MDTypography>
                    <MDBox>
                      <MDTypography component='div' variant='button' color='text'>
                        <p>
                          {criteria.find((item) => item.code === 'PO_CASHFLOW')?.name}:{' '}
                          {Func.numberDisplay(
                            criteria.find((item) => item.code === 'PO_CASHFLOW')?.value,
                            2
                          )}{' '}
                          บาท
                        </p>
                        <p>
                          {criteria
                            .find((item) => item.code === 'PO_CASHFLOW')
                            ?.name.replace('ต่อเดือน', '')}
                          คงเหลือ:{' '}
                          {Func.numberDisplay(
                            criteria.find((item) => item.code === 'PO_CASHFLOW')?.balance,
                            2
                          )}{' '}
                          บาท
                        </p>
                        <p>
                          {criteria.find((item) => item.code === 'PO_CREDIT')?.name}:{' '}
                          {Func.numberDisplay(
                            criteria.find((item) => item.code === 'PO_CREDIT')?.value,
                            2
                          )}{' '}
                          บาท
                        </p>
                        <p>
                          {criteria
                            .find((item) => item.code === 'PO_CREDIT')
                            ?.name.replace('ต่อเดือน', '')}
                          คงเหลือ:{' '}
                          {Func.numberDisplay(
                            criteria.find((item) => item.code === 'PO_CREDIT')?.balance,
                            2
                          )}{' '}
                          บาท
                        </p>
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
          {/* <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="shopping_bag"
                title="ใบสั่งซื้อ"
                count={stat.stat2.count}
                percentage={{
                  color: stat.stat2.color,
                  amount: stat.stat2.amount,
                  label: stat.stat2.label,
                }}
              />
            </MDBox>
          </Grid> */}
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon='check_circle'
                title='อนุมัติ'
                count={stat.stat3.count}
                percentage={{
                  color: stat.stat3.color,
                  amount: stat.stat3.amount,
                  label: stat.stat3.label,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color='error'
                icon='cancel'
                title='ปฏิเสธ'
                count={stat.stat4.count}
                percentage={{
                  color: stat.stat4.color,
                  amount: stat.stat4.amount,
                  label: stat.stat4.label,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color='primary'
                icon='real_estate_agent'
                title='รับชั่วคราว'
                count={stat.stat5.count}
                percentage={{
                  color: stat.stat5.color,
                  amount: stat.stat5.amount,
                  label: stat.stat5.label,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color='success'
                icon='add_business'
                title='ใบรับเข้า'
                count={stat.stat6.count}
                percentage={{
                  color: stat.stat6.color,
                  amount: stat.stat6.amount,
                  label: stat.stat6.label,
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderChart = () => {
    if (loading) {
      return (
        <MDBox mt={2} mb={2}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} lg={4}>
              <Card>
                <CardHeader
                  title={<Skeleton animation='wave' height={10} width='40%' sx={{ mb: 1 }} />}
                  subheader={<Skeleton animation='wave' height={10} width='80%' />}
                />
                <CardContent sx={{ pt: 1.5, pb: 0, px: 1.5 }}>
                  <Skeleton variant='rectangular' height={300} />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={8}>
              <Card>
                <CardHeader
                  title={<Skeleton animation='wave' height={10} width='40%' sx={{ mb: 1 }} />}
                  subheader={<Skeleton animation='wave' height={10} width='80%' />}
                />
                <CardContent sx={{ pt: 1.5, pb: 0, px: 1.5 }}>
                  <Skeleton variant='rectangular' height={300} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      );
    }

    return (
      <MDBox mb={3} mt={1}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={4}>
            <Card sx={{ height: '100%' }}>
              <MDBox py={3} pr={2} pl={3}>
                <MDBox>
                  <MDTypography variant='h6'>ใบสั่งซื้อ</MDTypography>
                  <MDBox mb={2}>
                    <MDTypography component='div' variant='button' color='text'>
                      {chartPie.description}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox mt={3}>
                  <Grid container alignItems='center'>
                    <Grid item xs={7}>
                      <PieChart chart={chartPie.chart} height='12.5rem' />
                    </Grid>
                    <Grid item xs={5}>
                      <MDBox pr={1}>
                        {listPie.map((item, i) => (
                          <MDBox mb={1} key={item.status}>
                            <MDBadgeDot
                              color={item.status_color}
                              size='sm'
                              badgeContent={item.status_name}
                            />
                          </MDBox>
                        ))}
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} lg={8}>
            <DefaultLineChart
              title='จำนวนเปิดใบสั่งซื้อ'
              description={
                <MDBox display='flex' justifyContent='space-between'>
                  <MDBox display='flex' ml={-1}>
                    <MDBadgeDot color='warning' size='sm' badgeContent='แก้ไขข้อมูล' />
                    <MDBadgeDot color='primary' size='sm' badgeContent='ตรวจสอบราคา' />
                    <MDBadgeDot color='info' size='sm' badgeContent='ขออนุมัติ' />
                    <MDBadgeDot color='info' size='sm' badgeContent='อนุมัติ' />
                    <MDBadgeDot color='error' size='sm' badgeContent='ไม่อนุมัติ' />
                    <MDBadgeDot color='info' size='sm' badgeContent='สั่งซื้อ' />
                    <MDBadgeDot color='info' size='sm' badgeContent='รับบางส่วน' />
                    <MDBadgeDot color='success' size='sm' badgeContent='เสร็จสิ้น' />
                  </MDBox>
                </MDBox>
              }
              chart={chartLine.chart}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderBar = () => {
    if (loading) {
      return (
        <MDBox mt={2} mb={2}>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={6}>
              <Card>
                <CardHeader
                  title={<Skeleton animation='wave' height={10} width='40%' sx={{ mb: 1 }} />}
                  subheader={<Skeleton animation='wave' height={10} width='80%' />}
                />
                <CardContent sx={{ pt: 1.5, pb: 0, px: 1.5 }}>
                  <Skeleton variant='rectangular' height={300} />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Card>
                <CardHeader
                  title={<Skeleton animation='wave' height={10} width='40%' sx={{ mb: 1 }} />}
                  subheader={<Skeleton animation='wave' height={10} width='80%' />}
                />
                <CardContent sx={{ pt: 1.5, pb: 0, px: 1.5 }}>
                  <Skeleton variant='rectangular' height={300} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      );
    }

    return (
      <MDBox mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <VerticalBarChart
              title='มูลค่าการสั่งซื้อ'
              description='ยอดสั่งซื้อต่อวัน'
              chart={chartVertical.chart}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <HorizontalBarChart
              title='จำนวนการเปิดใบสั่งซื้อ'
              description='จัดลำดับย้อนหลัง 7 วัน ล่าสุด'
              chart={chartHorizontal.chart}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, []);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.dashboard`), t(`menu.dashboard_purchase`)]} />
      <MDBox py={3}>
        {renderStat()}
        {renderChart()}
        {renderBar()}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardPurchase;
